import React from 'react';
import { useFormikContext } from 'formik';
import { MenuItem, Typography } from '@mui/material';
//
import { Cheque } from '@components';
import { FormikContext, FormikField } from '@components/formik';
import { Api, fmt } from '@utils';
import { useAuthContext } from '../auth';

const BankDetails: React.FC = () => {
  const { setBankCheckData } = React.useContext(FormikContext);
  const [isErr, setIsErr] = React.useState(false);

  // Get formik field values
  const { values } = useFormikContext<any>();

  // Get OB data from AuthContext
  const { obData } = useAuthContext();

  React.useEffect(() => {
    const _checkIns = async () => {
      try {
        const { data } = await Api.post('/check-ins', {
          inst_num: values.institution.toString(),
        });
        if (data) {
          const { inst_num, bank_name, locations } = data.data;

          const _checkData = {
            inst_num,
            bank_name,
            trans_number: locations.map((loc: any) => loc.trans_number),
          };

          setBankCheckData(_checkData);
          setIsErr(false);
        }
      } catch (err) {
        console.log(err);
        setIsErr(true);
        // setFieldError('institution', 'Invalid institution number');
      }
    };

    if (values?.transit) _checkIns();
  }, [values]);

  return (
    <>
      <Typography
        variant="h3"
        component="h2"
        gutterBottom
        sx={{
          fontWeight: 500,
          fontSize: 40,
        }}
      >
        Add your bank to recieve payouts
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        color="text.secondary"
        sx={{
          fontWeight: 400,
          letterSpacing: 1,
        }}
      >
        A payout is the transfer of funds from {import.meta.env.VITE_SITE} to
        your bank account.
      </Typography>

      <FormikField name="currency" label="Currency" disabled select>
        <MenuItem value="cad">CAD - Canadian Dollar</MenuItem>
        {/* <MenuItem value="usd">USD - US Dollar</MenuItem> */}
      </FormikField>

      <Cheque
        mt={4}
        name={values?.businessName || 'John Doe'}
        // bank="TD Canada Trust"
        verified={obData?.ac_ownership?.verified}
        number={fmt.getLastDigits(values?.account, 8) || '..12345678'}
        transit={values?.transit || '00000'}
        institute={values?.institution || '000'}
      />

      <FormikField
        name="institution"
        label="Institution number"
        placeholder="000"
        allowType="number"
        limitChars={3}
        helperText={isErr && 'Invalid institution number'}
      />

      <FormikField
        name="transit"
        label="Transit number"
        placeholder="12345"
        allowType="number"
        limitChars={5}
      />

      <FormikField
        name="account"
        label="Account number"
        placeholder="000123456789"
        allowType="number"
        limitChars={16}
      />

      <FormikField
        name="confirmAc"
        label="Confirm account number"
        placeholder="000123456789"
        allowType="number"
        limitChars={16}
      />
    </>
  );
};

export default BankDetails;
